import { ISearchServiceMock } from "./search.types";

export const mockSearchService = (): ISearchServiceMock => ({
    autoComplete: jest.fn(),
    search: jest.fn(),
    // getSaleById: jest.fn(),
    // createSale: jest.fn(),
    // syncSale: jest.fn()
});
